import { InjectionToken } from '@angular/core';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';

export const FEEDBACK_REPORT_ENDPOINT = new InjectionToken<() => string>(
  'FEEDBACK_REPORT_ENDPOINT',
  {
    providedIn: 'root',
    factory: () => () => API_ENDPOINTS.feedback.reports,
  },
);
